export default class Constantes {
  // rotas
  static tela_login         = '/login';
  static tela_painel        = '/painel';
  static tela_agendamento   = '/agendar/:slug';

  // apis
  static api_acesso             = 'acesso.php';
  static api_criar_horarios     = 'criar_horarios.php';
  static api_listar_horarios    = 'listar_horarios.php';
  static api_agendar            = 'agendar.php';
  static api_checar_reagendamento = 'checar_reagendamento.php';
  static api_reagendar_agendamento = 'reagendar_agendamento.php';
  static api_apagar_horarios    = 'apagar_horarios.php';
  static api_listar_agendamentos = 'listar_agendamentos.php';
  static api_criar_tenant       = 'criar_tenant.php';
  static api_contratar          = 'contratar.php';
  static api_atualizar_tenant   = 'atualizar_tenant.php'; 
  static api_consultar_pix   = 'consultar_pix.php';
  static api_obter_valores      = 'obter_valores.php';
  static api_listar_pagamentos  = 'listar_pagamentos.php'; // <-- NOVA LINHA
  static api_aplicar_cupom = 'api_aplicar_cupom.php';
  static api_listar_cupons_resgatados ='api_listar_cupons_resgatados.php';
  static api_listar_indicacoes = 'api_listar_indicacoes.php';
  static api_obter_config_indicacao = 'api_obter_config_indicacao.php';
  static api_agendar_manualmente = 'agendar_manualmente.php';
  static api_remover_horario = 'apagar_horarios.php';
  // Adicione junto com as outras APIs
static api_salvar_personalizacao ='api_salvar_personalizacao.php';
  // PIX e Validações Adicionadas
  static api_pix_create_payment = 'pix/create_payment.php';
  static api_verificar_slug     = 'verificar_slug.php';
  static api_registrar_usuario  = 'registrar_usuario.php';
  // msgs
  static msg_erro_conexao_bd    = 'Não foi possível conectar ao servidor. Tente novamente.';
  static msg_inserido_sucesso   = 'Operação realizada com sucesso!';
  static msg_campos_obrigatorios = 'Preencha todos os campos obrigatórios.';

  // botoes
  static botao_cancelar = 'Cancelar';
  static botao_confirmar = 'Confirmar';

  static versao= '1.0.19';
}